import type { FC } from 'react';
import { useAboutRoute } from '../../pages/about';
import { useComingSoonRoute } from '../../pages/coming-soon';
import { useProjectsRoute } from '../../pages/projects';
import { useHighlightsRoute } from '../../pages/highligths';

type Url = string;
export type Path = `/${Url}`;
export type Route = {
  element: FC;
  path: Path;
};
export const useAppRoutes = () => {
  const { route: aboutRoute } = useAboutRoute();
  const { route: comingSoonRoute } = useComingSoonRoute();
  const { route: projectsRoute } = useProjectsRoute();
  const { route: highlightsRoute } = useHighlightsRoute();

  const appRoutes: Array<Route> = [aboutRoute, comingSoonRoute, projectsRoute, highlightsRoute];

  return { appRoutes };
};
